import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DacConfig } from "../../shared/services/dac-config.service";
import { AuthService } from 'app/login/services/auth.service';
import { ClientSearchService } from '../services/client-search.service';
import { AlertService } from 'app/shared/services/alert.service';
import { Capability } from 'app/shared/models/capability';
import { Router, ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';
import { Role } from 'app/shared/models/role';
var ClientListComponent = /** @class */ (function () {
    function ClientListComponent(changeRef, authService, dacConfig, clientSearchService, alertService, router, subscriptionService, route) {
        var _this = this;
        this.changeRef = changeRef;
        this.authService = authService;
        this.dacConfig = dacConfig;
        this.clientSearchService = clientSearchService;
        this.alertService = alertService;
        this.router = router;
        this.subscriptionService = subscriptionService;
        this.route = route;
        this._clients = [];
        this.tokensEnabled = false;
        this.isSearching = false;
        this._userSubscription = this.authService.getLoginState().subscribe(function (loginState) {
            _this._currentUser = loginState.user;
            if (_this.dacConfig.isFeatureEnabled("assessments.tokens.enabled")) {
                if (loginState.user && loginState.user.hasCapability(Capability.CAN_BUY_TOKENS)) {
                    _this.tokensEnabled = true;
                }
            }
            if (loginState.user) {
                _this._userHasActiveServiceSubscription = loginState.user.hasActiveSubscription();
            }
            // we don't allow show all users to work if they don't have permission to this.
            if (_this._currentUser.role > Role.Admin) {
                _this.clientSearchService.ShowAllUsers = false;
            }
        });
    }
    ClientListComponent.prototype.ngOnDestroy = function () {
        this._userSubscription.unsubscribe();
    };
    ClientListComponent.prototype.ngOnInit = function () {
        this.getDefaultClientList();
    };
    Object.defineProperty(ClientListComponent.prototype, "Clients", {
        get: function () {
            return this._clients;
        },
        enumerable: true,
        configurable: true
    });
    ClientListComponent.prototype.hasMoreResults = function () {
        return this.clientSearchService.hasMoreResults();
    };
    Object.defineProperty(ClientListComponent.prototype, "lastSearchValue", {
        get: function () {
            return this.clientSearchService.SearchValue;
        },
        enumerable: true,
        configurable: true
    });
    ClientListComponent.prototype.addClient = function () {
        if (this.canAddClient) {
            this.router.navigate(['new'], { relativeTo: this.route });
        }
        else {
            this.subscriptionService.notifySubscriptionRequired();
        }
    };
    Object.defineProperty(ClientListComponent.prototype, "canAddClient", {
        get: function () {
            return this.dacConfig.isFeatureEnabled("client.add") && this._userHasActiveServiceSubscription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientListComponent.prototype, "showAllUsers", {
        get: function () {
            return this.clientSearchService.ShowAllUsers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientListComponent.prototype, "exactMatch", {
        get: function () {
            return this.clientSearchService.ExactMatch;
        },
        enumerable: true,
        configurable: true
    });
    ClientListComponent.prototype.toggleAllUsers = function () {
        this.clientSearchService.ShowAllUsers = !this.clientSearchService.ShowAllUsers;
        this.resetSearch(); // clear out the search since we changed the toggle here.
    };
    ClientListComponent.prototype.toggleExactMatch = function () {
        this.clientSearchService.ExactMatch = !this.clientSearchService.ExactMatch;
    };
    ClientListComponent.prototype.doSearch = function () {
        this.searchByNameInvalid = false;
        var firstName = this.searchFirstName || "";
        var lastName = this.searchLastName || "";
        var clientID = this.searchClientID || "";
        var email = this.searchEmail || "";
        if (!(clientID || email)
            && (firstName == "" || lastName == "")) {
            this.searchByNameInvalid = true;
            this.alertService.error("Missing client id, or first and last name to do search");
            return;
        }
        this.runSearch(firstName, lastName, clientID, email);
    };
    ClientListComponent.prototype.resetSearch = function () {
        this.searchByNameInvalid = false;
        this.searchFirstName = "";
        this.searchLastName = "";
        this.searchClientID = "";
        this.searchEmail = "";
        this._clients = [];
        this.runSearch(this.searchFirstName, this.searchLastName, this.searchClientID, this.searchEmail);
    };
    ClientListComponent.prototype.runSearch = function (firstName, lastName, clientID, email) {
        var _this = this;
        this.isSearching = true;
        var user = this.getUserForQuery();
        var search = {
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            id: clientID.trim(),
            email: encodeURIComponent(email.trim()),
            exactMatch: this.exactMatch === true
        };
        this._clients = []; // clear our client list as we are doing a search.
        this.clientSearchService.search(search, user).then(function (results) {
            _this._clients = results;
            _this.isSearching = false;
        })
            .catch(function (error) { return _this.handleSearchError(error); });
    };
    ClientListComponent.prototype.loadMore = function () {
        var _this = this;
        this.isSearching = true;
        this.clientSearchService.loadMore().then(function (results) {
            _this.isSearching = false;
            _this._clients = results;
        })
            .catch(function (error) { return _this.handleSearchError(error); });
    };
    ClientListComponent.prototype.getUserForQuery = function () {
        if (this.clientSearchService.ShowAllUsers) {
            return null;
        }
        return this._currentUser;
    };
    ClientListComponent.prototype.getDefaultClientList = function () {
        var _this = this;
        var user = this.getUserForQuery();
        this.isSearching = true;
        this.clientSearchService.getClientList(user).then(function (results) {
            _this.isSearching = false;
            _this._clients = results;
            _this.changeRef.detectChanges();
        })
            .catch(function (error) { return _this.handleSearchError(error); });
    };
    ClientListComponent.prototype.handleSearchError = function (error) {
        this.alertService.error("There was an error retrieving the results from the server.  Please check your network connection and try again or contact support");
        console.error(error);
        this.isSearching = false;
    };
    return ClientListComponent;
}());
export { ClientListComponent };



// WEBPACK FOOTER //
// ./src/app/admin/client-list/client-list.component.ts.pre-build-optimizer.js